// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../graphql/public/PublicSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type OrganisationQueryVariables = PublicSchemaTypes.Exact<{ [key: string]: never; }>;


export type OrganisationQuery = (
  { __typename?: 'Query' }
  & { organisation?: PublicSchemaTypes.Maybe<(
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PublicSchemaTypes.OrganisationModelGqlBase, 'id' | 'allow_signup' | 'domain_lock' | 'can_students_update_profile' | 'billing_status' | 'email_comments' | 'email_content' | 'user_id'>
    & { features: (
      { __typename?: 'OrganisationFeatures' }
      & Pick<PublicSchemaTypes.OrganisationFeatures, 'campaigns' | 'campaign_templating' | 'dashboards' | 'custom_email_sender_address' | 'SCORM' | 'search_analytics' | 'custom_font' | 'custom_i18n' | 'Slack' | 'Fourth' | 'sms' | 'account_name_login' | 'msteams' | 'certificates' | 'bongo' | 'gsuite' | 'microsoft_365' | 'multiple_senders' | 'custom_smtp' | 'video_analytics' | 'SCORM_360'>
      & { link_unfurling?: PublicSchemaTypes.Maybe<(
        { __typename?: 'LinkUnfurlingData' }
        & Pick<PublicSchemaTypes.LinkUnfurlingData, 'enabled' | 'switched_on'>
      )>, cpd?: PublicSchemaTypes.Maybe<(
        { __typename?: 'CPDData' }
        & Pick<PublicSchemaTypes.CpdData, 'enabled' | 'switched_on'>
      )> }
    ), oauthConfigs: Array<(
      { __typename?: 'OauthConfigModel' }
      & Pick<PublicSchemaTypes.OauthConfigModel, 'id' | 'enabled' | 'provider'>
    )>, g_suite?: PublicSchemaTypes.Maybe<(
      { __typename?: 'OrganisationGSuite' }
      & Pick<PublicSchemaTypes.OrganisationGSuite, 'calendar' | 'drive' | 'driveServiceAccount' | 'linkedResourcesDriveId'>
    )>, styles: (
      { __typename?: 'OrganisationStyles' }
      & Pick<PublicSchemaTypes.OrganisationStyles, 'logo' | 'colors'>
    ) }
  )> }
);


export const OrganisationDocument = gql`
    query organisation {
  organisation {
    id
    allow_signup
    domain_lock
    can_students_update_profile
    billing_status
    email_comments
    email_content
    user_id
    features {
      campaigns
      campaign_templating
      dashboards
      custom_email_sender_address
      SCORM
      search_analytics
      custom_font
      custom_i18n
      Slack
      Fourth
      sms
      account_name_login
      msteams
      certificates
      link_unfurling {
        enabled
        switched_on
      }
      cpd {
        enabled
        switched_on
      }
      bongo
      gsuite
      microsoft_365
      multiple_senders
      custom_smtp
      video_analytics
      SCORM_360
    }
    oauthConfigs {
      id
      enabled
      provider
    }
    g_suite {
      calendar
      drive
      driveServiceAccount
      linkedResourcesDriveId
    }
    styles {
      logo
      colors
    }
  }
}
    `;

/**
 * __useOrganisationQuery__
 *
 * To run a query within a React component, call `useOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
      }
export function useOrganisationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
        }
export type OrganisationQueryHookResult = ReturnType<typeof useOrganisationQuery>;
export type OrganisationLazyQueryHookResult = ReturnType<typeof useOrganisationLazyQuery>;
export type OrganisationQueryResult = Apollo.QueryResult<OrganisationQuery, OrganisationQueryVariables>;